// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// tools js
global.$ = jQuery;

require("jquery");
require("webpack-jquery-ui");
// require('webpack-jquery-ui/css');

require("./jquery-ui-timepicker-addon.js");

require("popper.js");
window.ApexCharts = require("./apexcharts.min");
// require('./apexcharts.esm')
require("foundation-sites");
require("foundation-datepicker");
// project js files
require("./jquery.scrollbar.min");
require("./ajax_with_spinner");
require("./docs");
require("shopify_app");
require("selectize");
require("dropzone");
require("./freeze_table");
window.Pickr = require("@simonwep/pickr");
window.moment = require("moment/moment");

// import moment from 'moment/moment';

require("./main");
require("./repeater");
require("trix");
require("@rails/actiontext");

window.Cookies = require("js-cookie/src/js.cookie");
